import { printJobAvailabilityRefreshPopulate } from './print-job-refresh-populate'

/** То же для строки очереди станка: обновляется только вложенное задание, sort не запрашивается */
export const printQueueEntryAvailabilityRefreshPopulate = {
    fields: ['documentId'],
    populate: {
        print_job: printJobAvailabilityRefreshPopulate,
    },
}
